<div *ngIf="showRegistration; else metaInformation">
    <aumico-users-registration
        (registrationFormStatus)="onRegisterFormStatusChange($event)"
        (registrationData)="onRegisterFormValueChange($event)"
        (pricesClicked)="openPricesLink()"
        (privacyPolicyClicked)="openPrivacyPolicyLink()"
        (termsAndConditionsClicked)="openTermsAndConditionsLink()"
        (agreementOnOrderDataProcessingClicked)="openAgreementOnOrderDataProcessingLink()"
    ></aumico-users-registration>
    <div class="continue-button">
        <button color="primary" aum-button [disabled]="!isRegisterFormValid" (click)="showMetaInformation()">
            {{localizations.aumico_users_signup_continue_button| i18next}}
        </button>
    </div>
</div>
<ng-template #metaInformation>
    <aumico-users-personal-information
        [supportedLocales]="supportedLocales"
        [defaultLanguage]="defaultLanguage"
        (personaInformationFormStatus)="onPersonalInformationFormStatusChange($event)"
        (personalInformationData)="onPersonalInformationFormValueChange($event)"
    ></aumico-users-personal-information>
    <div class="continue-button">
        <button color="primary" aum-button [disabled]="!isPersonalInformationFormValid" (click)="createAccount()">
            <span *ngIf="!isCreateAccountButtonClicked"
                >{{localizations.aumico_reports_registration_create_account_button| i18next}}</span
            >
            <span *ngIf="isCreateAccountButtonClicked"
                >{{localizations.aumico_users_signup_creating_your_account_button| i18next}}</span
            >
            <span *ngIf="isCreateAccountButtonClicked" class="loading"
                ><mat-icon class="loading-icon" svgIcon="aumico-pattern-icon-loading"></mat-icon
            ></span>
        </button>
    </div>
</ng-template>

<mat-error *ngIf="backendError">{{localizations.aumico_errors_server_error| i18next }}</mat-error>
<mat-error *ngIf="userEmailAlreadyExist">{{localizations.aumico_errors_server_error| i18next }}</mat-error>
